import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=29143028&scoped=true&"
import script from "./UsersCard.vue?vue&type=script&lang=js&"
export * from "./UsersCard.vue?vue&type=script&lang=js&"
import style0 from "./UsersCard.vue?vue&type=style&index=0&id=29143028&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29143028",
  null
  
)

export default component.exports